<template>
  <div>
    <v-snackbar v-if="showInstallMessage" :value="showInstallMessage" class="InstallMessage" color="grey lighten-3" absolute light app multi-line :timeout="-1">
      <template v-if="isIos">
        <b>App installieren:</b> Tippe in Safari auf <svg class="ios-share" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M12,1L8,5H11V14H13V5H16M18,23H6C4.89,23 4,22.1 4,21V9A2,2 0 0,1 6,7H9V9H6V21H18V9H15V7H18A2,2 0 0,1 20,9V21A2,2 0 0,1 18,23Z" /></svg> (Teilen), bei neueren iOS-Versionen zuerst auf <b>&bull;&bull;&bull;</b> (Mehr), dann auf <b>Zum Home-Bildschirm</b> <svg class="ios-add-to-home" style="width:24px;height:24px" viewBox="0 0 24 24">
            <path d="M19,19V5H5V19H19M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M11,7H13V11H17V13H13V17H11V13H7V11H11V7Z" />
        </svg> und bestätige mit <b>Hinzufügen</b>. Die App muss dafür in <b>Safari</b> geöffnet sein.
      </template>
      <template v-else>
        <b>App installieren:</b>
        <template v-if="deferredPrompt">Installiere die App für den schnellen Zugriff vom Startbildschirm.</template>
        <template v-else>Tippe in Chrome auf <b>&#8942;</b> (Menü) und dann auf <b>App installieren</b> bzw. <b>Zum Startbildschirm hinzufügen</b>.</template>
      </template>
      <template v-slot:action="{ attrs }">
        <v-btn v-if="!isIos && deferredPrompt" text color="primary" v-bind="attrs" @click="installApp">Installieren</v-btn>
        <v-icon v-bind="attrs" @click="dismissInstall">mdi-close</v-icon>
      </template>
    </v-snackbar>
    <v-dialog v-else-if="updateExists" :value="updateExists" persistent max-width="320" class="UpdateMessage">
        <v-card class="text-center pa-4">
            <v-card-text class="text-body-1">Ein Update ist verfügbar</v-card-text>
            <v-btn color="primary" @click="refreshApp">
                Update installieren
            </v-btn>
        </v-card>
    </v-dialog>
    <v-dialog v-model="updateSuccess" persistent max-width="320" class="UpdateSuccessMessage">
        <v-card class="text-center pa-4">
            <v-card-text class="text-body-1">Update erfolgreich installiert</v-card-text>
            <v-btn color="success" @click="confirmUpdateSuccess">
                OK
            </v-btn>
        </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default { 
    name: "pwa",
    data() {
      return {
        showInstallMessage: false,
        deferredPrompt: null,
        // refresh variables
        refreshing: false,
        registration: null,
        updateExists: false,
        updateSuccess: false,
      }
    },
    created() {
      /*
      if (this.isIos && !this.isInStandaloneMode) {
          this.showInstallMessage = true;
      }
      */
      // Listen for our custom event from the SW registration
      document.addEventListener('swUpdated', (e) => {
        console.log('swUpdated',e);
        this.updateAvailable(e)
      })

      // Prevent multiple refreshes
      if (navigator.serviceWorker){
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('controllerchange called')
          if (this.refreshing) return
          this.refreshing = true
          // Der neue Service Worker hat die Kontrolle übernommen -> Update ist erfolgreich installiert.
          // Reload erfolgt erst, nachdem der Nutzer bestätigt hat.
          this.updateSuccess = true
        })
      }
    },
    mounted() {
      this.showInstallMessage = this.showInstall;
      // Android/Chrome: Installationsdialog des Browsers verwenden, sobald verfügbar
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        this.deferredPrompt = e
      })
      window.addEventListener('appinstalled', () => {
        this.deferredPrompt = null
        this.showInstallMessage = false
      })
    },
    methods: {
      installApp() {
        if (!this.deferredPrompt) return
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.finally(() => {
          this.deferredPrompt = null
          this.showInstallMessage = false
        })
      },
      dismissInstall() {
        this.showInstallMessage = false
        try { localStorage.setItem('install-hint-dismissed', '1') } catch (e) { /* ignorieren */ }
      },
      // Store the SW registration so we can send it a message
      // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
      // To alert the user there is an update they need to refresh for
      updateAvailable(event) {
          console.log('updateAvailable called')
        this.registration = event.detail
        // Update automatisch aktivieren, ohne Rückfrage
        this.refreshApp()
      },
  
      // Called when the user accepts the update
      refreshApp() {
        console.log('refreshApp called')
        this.updateExists = false
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) return
        // send message to SW to skip the waiting and activate the new SW
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      },

      // Called when the user confirms the successful update
      confirmUpdateSuccess() {
        this.updateSuccess = false
        window.location.reload()
      },
    },
    computed:{
      showInstall(){
        try { if (localStorage.getItem('install-hint-dismissed')) return false } catch (e) { /* ignorieren */ }
        if (this.isStandalone) return false
        return this.isIos || this.isAndroid
      },
      isStandalone(){
        return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true
      },
      isAndroid(){
        return /android/i.test(window.navigator.userAgent)
      },
      isIos(){
          const userAgent = window.navigator.userAgent.toLowerCase();
          // iPadOS meldet sich teils als Mac mit Touch
          return /iphone|ipad|ipod/.test( userAgent ) || (userAgent.includes('macintosh') && navigator.maxTouchPoints > 1);
      },
    }
  }
</script>

<style scoped>
.InstallMessage{
  z-index: 7;
}
.InstallMessage>>>.v-snack__content{
  font-size: 0.8rem !important;
}
.ios-add-to-home,
.ios-share{
    position: relative;
}
.ios-share{
    top: 3px;
}
.ios-add-to-home{
    top: 5px;
}
svg {
  fill: currentColor;
}

</style>